import type { ErrorEvent } from '@sentry/angular'
import { isChunkLoadError } from './chunk-load-util'

// Error.message is not always a string: HttpErrorInterceptor builds an HttpError whose
// message is the parsed JSON response body, so string methods must not be assumed.
function asText(value: unknown): string {
  return typeof value === 'string' ? value : ''
}

/**
 * Sentry beforeSend filter: true when the event is known noise and should be dropped.
 * Must never throw, or Sentry reports the filter's own TypeError instead of the event.
 */
export function shouldDropSentryEvent(event: ErrorEvent, originalException: unknown): boolean {
  const error: any = originalException
  const message = error instanceof Error ? asText(error.message) : asText(error)
  const stack = error instanceof Error ? asText(error.stack) : ''

  // suppress primeNG-17 specific android error which is not actionable
  if (
    message.includes("reading 'begin'") &&
    (stack.includes('primeng') || stack.includes('handleAndroidInput'))
  ) {
    return true
  }

  // Suppress stale-chunk errors, the rejection handler in main.ts reloads the page to recover
  if (isChunkLoadError(message)) {
    return true
  }

  // Suppress network / offline errors
  return (
    error?.status === 0 ||
    message.includes('not connected to the internet') ||
    message.includes('HTTP 0') ||
    !!event.exception?.values?.some(v =>
      asText(v.value).includes('not connected to the internet')
    )
  )
}
